import api from "@/lib/api";
import { toast } from "sonner";

// Misma regla en todos los módulos: e-CF con XML firmado guardado
export const hasSignedXml = (d) => !!(d?.is_electronic && (d.has_xml ?? (d.ecf_xml || d.ecf_xml_signed)));

// Descarga un archivo autenticado respetando el nombre del Content-Disposition.
export async function downloadAuthFile(path, fallbackName) {
  const res = await api.get(path, { responseType: "blob" });
  const m = (res.headers?.["content-disposition"] || "").match(/filename="([^"]+)"/);
  const u = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = u;
  a.download = m ? m[1] : fallbackName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(u), 1000);
}

export async function downloadEcfXml(path, fallbackName) {
  try {
    await downloadAuthFile(path, fallbackName);
  } catch {
    toast.error("Este documento aún no tiene XML firmado");
  }
}

// Consulta el estado en DGII por trackId y muestra el resultado.
export async function verifyDgiiStatus(ncf, onDone) {
  try {
    const { data } = await api.post(`/dgii/phase4/refresh-status/${ncf}`);
    const est = data.new_status || "desconocido";
    if (est === "aceptado") toast.success(`DGII: Aceptado · ${ncf}`);
    else if (est === "rechazado") toast.error(`DGII: Rechazado · ${data.error || ncf}`);
    else toast.message(`DGII: ${est} · ${ncf}`);
    onDone && onDone();
  } catch (e) {
    toast.error(e.response?.data?.detail || "Error verificando DGII");
  }
}
